const WORDS = ["Consulting", "Strategy", "Growth", "Excellence", "Careers", "Business Setup", "Advisory"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="bg-[#0B1F3A] border-t border-white/10 py-6 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-2xl md:text-3xl font-semibold text-white/40 px-8">
              {w}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#C8A75D]" />
          </span>
        ))}
      </div>
    </div>
  );
}
